import {
	addOrderReturnOrStaleComment,
	getConsultantReturnedAndStaleOrders,
} from '@/API/repositories/order';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';

const useConsultantFollowUpShipments = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [displayedRows, setDisplayedRows] = useState();
	const [modalOrderId, setModalOrderId] = useState(null);

	const isLoading = hasUnfilledRequest(getConsultantReturnedAndStaleOrders);

	const fetchStaleOrders = async () => {
		const response = await makeRequest(
			getConsultantReturnedAndStaleOrders.bind(null),
		);
		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setDisplayedRows(response.data);
	};

	const openModal = (orderId) => {
		setModalOrderId(orderId);
	};

	const closeModal = () => {
		setModalOrderId(null);
	};

	const submitModal = async (e) => {
		e.preventDefault();
		const call = {
			result: e.target.result.value,
			comment: e.target.comment.value,
		};

		if (!call.result) {
			return addMessage('Result should not be empty');
		}
		if (call.result === 'picked_up' && !call.comment) {
			return addMessage('Add comment if picked up');
		}

		const response = await makeRequest(
			addOrderReturnOrStaleComment.bind(null, modalOrderId, call),
		);
		if (!response.data) {
			addMessage('Something went wrong', 'error');
		}

		closeModal();
		fetchStaleOrders();
	};

	useEffect(() => {
		fetchStaleOrders();
	}, []);

	return {
		displayedRows,
		fetchStaleOrders,
		isLoading,
		modalOrderId,
		openModal,
		closeModal,
		submitModal,
	};
};

export default useConsultantFollowUpShipments;
